import { render, staticRenderFns } from "./PagamentosAprovacoesTabelaDash.vue?vue&type=template&id=c9415b6e&lang=html&"
import script from "./PagamentosAprovacoesTabelaDash.vue?vue&type=script&lang=js&"
export * from "./PagamentosAprovacoesTabelaDash.vue?vue&type=script&lang=js&"
import style0 from "./PagamentosAprovacoesTabelaDash.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../../../../shared-components/generico/Pagination.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/PagamentosAprovacoesTabelaDash.vue
// module id = 1255
// module chunks = 28